import { axiosApi } from "../axios/axios_config";

export async function getWordsaware(id, pagination,filter) {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const studyNumber = JSON.parse(localStorage.getItem("studyNumber"));

  let endpoint = (id) ? `wordsaware?userId=${id}` : `wordsaware?userId=${userInfo.id}`;

   if(studyNumber){
    endpoint += `&studyNumber=${studyNumber}`;
  }

  if (pagination) {
    endpoint = (id) ? `wordsaware?userId=${id}&pageIndex=${pagination.pageIndex}&pageSize=${pagination.pageSize}` : `wordsaware?userId=${userInfo.id}&pageIndex=${pagination.pageIndex}&pageSize=${pagination.pageSize}`;
  }

  if (filter && filter?.filterBy && filter?.filterValue) {
    endpoint += `&filterBy=${filter.filterBy}&filterValue=${filter.filterValue}`;
  }

  try {
    const { data, response } = await axiosApi({
      endpoint: endpoint,
      method: "GET",
      bodyData: null,

    });
    return { data, response };
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
